import { AsyncStatus } from 'lib-shared-types-api';

import { PhoneNumber } from '../../types/numbers.types';

export type ReadNumbersPaginatedState = {
  readonly items: readonly PhoneNumber[];
  readonly asyncStatus: AsyncStatus;
  readonly nextPagePath: string | null;
  readonly previousPagePath: string | null;
};

export type ReadNumbersPaginatedAction =
  | { type: 'fetchStarted'; direction?: 'next' | 'previous' }
  | {
      type: 'fetchSucceeded';
      items: readonly PhoneNumber[];
      nextPagePath: string | null;
      previousPagePath: string | null;
      infinite: boolean;
      direction?: 'next' | 'previous';
    }
  | { type: 'fetchFailed' };

export function createInitialState(): ReadNumbersPaginatedState {
  return {
    items: [],
    asyncStatus: 'uninitialized',
    nextPagePath: null,
    previousPagePath: null,
  };
}

function mergeItems({
  currentItems,
  nextItems,
  direction,
  infinite,
}: {
  currentItems: readonly PhoneNumber[];
  nextItems: readonly PhoneNumber[];
  direction?: 'next' | 'previous';
  infinite: boolean;
}): readonly PhoneNumber[] {
  if (!infinite || !direction) {
    return nextItems;
  }

  if (direction === 'next') {
    return [...currentItems, ...nextItems];
  }

  return [...nextItems, ...currentItems];
}

export function readNumbersPaginatedReducer(
  state: ReadNumbersPaginatedState,
  action: ReadNumbersPaginatedAction,
): ReadNumbersPaginatedState {
  switch (action.type) {
    case 'fetchStarted':
      return {
        ...state,
        asyncStatus: 'pending',
        nextPagePath: action.direction ? state.nextPagePath : null,
        previousPagePath: action.direction ? state.previousPagePath : null,
      };

    case 'fetchSucceeded':
      return {
        items: mergeItems({
          currentItems: state.items,
          nextItems: action.items,
          direction: action.direction,
          infinite: action.infinite,
        }),
        nextPagePath: action.nextPagePath,
        previousPagePath: action.previousPagePath,
        asyncStatus: 'fulfilled',
      };

    case 'fetchFailed':
      return {
        ...state,
        asyncStatus: 'rejected',
      };
  }
}
